import './styles.scss'

import React, { useRef, useCallback } from 'react'
import { useValues } from 'kea'

import I18n from 'lib/i18n'

import Map from './map-pigeon'
import List from './list'

import courseShowLogic from '~/scenes/course/show/logic'

const Locations = () => {
  const {
    course: { locations }
  } = useValues(courseShowLogic)

  const mapLocationSetterRef = useRef(null)

  const showMap = locations && locations.some(location => location.locationType !== 'webcam')

  const handleMapLoad = useCallback(setMapLocationFn => {
    mapLocationSetterRef.current = setMapLocationFn
  }, [])

  const handleListClick = useCallback(location => {
    const setMapLocation = mapLocationSetterRef.current

    if (
      setMapLocation &&
      location &&
      typeof location.latitude !== 'undefined' &&
      typeof location.longitude !== 'undefined'
    ) {
      setMapLocation(location)
    }
  }, [])

  return (
    <div className='location-container'>
      <div className='location-title'>{I18n.t('courses.show.location')}</div>
      {showMap && <Map onLoaded={handleMapLoad} />}
      <List onClick={handleListClick} />
    </div>
  )
}

export default Locations
